import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const UrgentCare = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="urgent care icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3 9.0002H5.3L4 15.0002H10L8.7 21H15.3L16.6 15.0002H22.6L23.9 9.0002H17.9L19.2 3L12.6 3.0002L11.3 9.0002ZM5.25 3.5C4.69772 3.5 4.25 3.94772 4.25 4.5C4.25 5.05228 4.69772 5.5 5.25 5.5H9.91667C10.469 5.5 10.9167 5.05228 10.9167 4.5C10.9167 3.94772 10.469 3.5 9.91667 3.5H5.25ZM0.25 7.25C0.25 6.69772 0.697715 6.25 1.25 6.25H5.91667C6.46895 6.25 6.91667 6.69772 6.91667 7.25C6.91667 7.80228 6.46895 8.25 5.91667 8.25H1.25C0.697715 8.25 0.25 7.80228 0.25 7.25ZM2.25 17.25C1.69772 17.25 1.25 17.6977 1.25 18.25C1.25 18.8023 1.69772 19.25 2.25 19.25H6.91667C7.46895 19.25 7.91667 18.8023 7.91667 18.25C7.91667 17.6977 7.46895 17.25 6.91667 17.25H2.25Z"
    />
  </svg>
)
